import Link from 'next/link';
import styled, { css } from 'styled-components';
import { ServicePlanTermWrapper } from 'components/ITeroTermsConditionsModal/ITeroTermsConditionsModal.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  margin-top: 1%;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`;

export const ContractContainer = styled.div`
  width: 70%;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    width: 100%;
  }
`;
export const ProposalSummaryWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    width: 100%;
    margin-top: 20px;
    margin-left: 0%;
  }
  margin-left: 10px;

  width: 30%;
`;

export const Proposal = styled.div<{ $rental?: boolean }>`
  display: grid;
  width: 100%;
  /* grid-template-columns: repeat(7, 1fr); */
  /* grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 2fr; */
  grid-template-columns: 3fr 1fr 1.5fr 1.5fr 1.5fr ${({ $rental }) =>
      $rental ? '1.5fr 1.5fr' : null};
  text-align: left;
  overflow: auto;
  border-radius: 5px;
  margin: 20px 0;
`;

export const Head = styled.div`
  display: contents;
  font-weight: 500;
`;

export const HeaderCell = styled.div`
  display: flex;
  align-items: center;

  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.8rem 1.25rem;
  color: rgba(0, 0, 0, 0.63);
  background-color: white;
  color: black;
  text-align: left;
`;

export const BodyRows = styled.div`
  display: contents;
`;

export const BodyCell = styled.div<{
  showCursor?: boolean;
  $noWrap?: boolean;
}>`
  position: relative;
  background-color: white;

  color: #6b7280;
  padding: 1.25rem;
  text-align: center;

  margin-top: 11px;

  cursor: ${({ showCursor }) => (showCursor ? 'pointer' : 'auto')};
  text-align: left;
  /* border: 1px solid red; */

  ${({ $noWrap }) =>
    $noWrap &&
    css`
      white-space: nowrap;
    `}
`;

export const HelperText = styled.span`
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  display: inline-block;
`;

export const SubOptions = styled.div`
  font-size: 0.9rem;
`;

export const BodyCellOptions = styled(BodyCell)`
  background-color: #f9fafb;
  color: #6b7280;
  padding: 1rem;
  font-size: 0.9rem;

  margin-top: 0;

  cursor: auto;

  border-top: 1px solid #dddddd;
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
`;

export const SummaryContainer = styled.div`
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
    justify-content: end;
  }
  height: max-content;
`;

export const Summary = styled.div`
  display: inline-block;

  font-size: 16px;
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 85%;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: block;
    width: auto;
  }
`;

export const SummaryTitle = styled.h3`
  font-weight: 500;
  font-size: 1.2rem;
  margin: unset;
`;

export const SummaryItem = styled.p`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 70px;

  > div {
    max-width: 170px;
  }
`;

export const SummaryItemLabel = styled.div`
  width: 45%;
`;

export const SummaryItemValue = styled.div`
  width: 55%;
  text-align: right;
`;

export const DiscountAmount = styled.span`
  color: green;
  font-weight: bold;
`;

export const TaxNote = styled.div`
  font-size: 0.8rem;
  /* font-style: italic; */
`;

export const TotalPrice = styled.div`
  font-weight: 500;
`;

export const Separator = styled.div`
  border-top: 1px solid #dddddd;
  margin-top: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

export const Discount = styled.div`
  font-size: 0.9rem;
  color: green;
  font-weight: bold;
`;

export const BodyCellContent = styled.div`
  text-align: left;
  line-height: 1.5rem;
`;

export const ProposalSubscription = styled(Proposal)<{
  $isMultipleScannerSubscriptions: boolean;
}>`
  grid-template-columns: ${({ $isMultipleScannerSubscriptions }) =>
    $isMultipleScannerSubscriptions
      ? '3fr 3fr 1fr 1.5fr  3fr 1.5fr'
      : '3fr 1fr 1.5fr 3fr 1.5fr'};
`;

export const TaxInfoWrapper = styled.i`
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 1rem;
  text-align: justify;
  &::before {
    content: '* ';
    color: rgba(212, 63, 88, 1);
    font-size: 1rem;
    vertical-align: top;
  }
`;
export const ProposalLinkWrapper = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary};
  cursor: pointer;
  font-weight: 500;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary};
`;

export const ServicePlanSubText = styled(ServicePlanTermWrapper)`
  font-style: italic;
  margin: unset;
`;

export const CalculationNote = styled.div`
  font-size: 1rem;
`;
